import axios from "axios";
import { apiEndpoint } from "@iso/lib/helpers/endpoint";
import { authHeader } from "@iso/lib/helpers/authHeader";

/**
 * The six Phase-2 contractor registers share one child-CRUD surface
 * (get-by-contractor / create / update / delete). Rather than six
 * hand-written services, this factory produces one per endpoint. The
 * profile passes the matching endpoint key from each register config.
 */
const makeRegisterService = (base) => ({
  list(contractorId) {
    return axios
      .get(`${base}/get-by-contractor`, {
        headers: authHeader(),
        params: { contractor_id: contractorId },
      })
      .then((res) => (res && res.status === 200 ? res.data : {}));
  },
  create(contractorId, item) {
    return axios
      .post(`${base}/create`, { contractor_id: contractorId, item }, { headers: authHeader() })
      .then((res) => (res && res.status === 200 ? res.data : {}));
  },
  update(id, item) {
    return axios
      .post(`${base}/update`, { id, item }, { headers: authHeader() })
      .then((res) => (res && res.status === 200 ? res.data : {}));
  },
  destroy(id) {
    return axios
      .post(`${base}/delete`, { id }, { headers: authHeader() })
      .then((res) => (res && res.status === 200 ? res.data : {}));
  },
});

export const registerServices = {
  "contractor-insurance": makeRegisterService(apiEndpoint.contractorInsurance),
  "contractor-worker": makeRegisterService(apiEndpoint.contractorWorker),
  "contractor-asset": makeRegisterService(apiEndpoint.contractorAsset),
  "contractor-licence": makeRegisterService(apiEndpoint.contractorLicence),
  "contractor-induction": makeRegisterService(apiEndpoint.contractorInduction),
  "contractor-safety-document": makeRegisterService(apiEndpoint.contractorSafetyDocument),
};
